import React from "react";
import { connect } from "react-redux";
import {
  Container,
  Paper,
  CssBaseline,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TablePagination,
  TableSortLabel,
  Button
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as companyApi from "../../api/companyApi";
import * as ClearingUtils from "./ClearingUtils";
import { withParams } from "../common/WithParams";

class ClearingDetailsAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearings: [],
      clearing: {},
      year: "",
      month: "",
      type: "Compensations",
      companyId: "",
      companiesByOrg: [],
      page: 0,
      rowsPerPage: 25,
      sortDirection: "desc",
      sortColumn: "damageYear",
    };
  }

  async componentDidMount() {
    try {
      const clearingId = this.props.params.id;
      if (clearingId) {
        const clearing = await ClearingUtils.getClearing(clearingId);
        if (clearing) {
          this.setState({ clearing });
          this.fetchClearings(clearingId);
        }

        const companiesByOrg = await companyApi.getCompaniesByOrg(clearing.organisationName);
        if (companiesByOrg) {
          companiesByOrg.sort(this.compareBy("companyName", "asc"));
          this.setState({ companiesByOrg });
        }
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  fetchClearings = async (clearingId) => {
    try {
      const { type, companyId, sortColumn, sortDirection } = this.state;
      const clearings = await ClearingUtils.getClearingsById(type, clearingId, companyId);
      if (clearings) {
        clearings.sort(this.compareBy(sortColumn, sortDirection));
        this.setState({ clearings });
      } else {
        this.setState({ clearings: [] });
      }
    } catch (error) {
      console.error("Error fetching clearings:", error);
      this.setState({ clearings: [] });
    }
  };

  onChange = async (e) => {
    const { name, value } = e.target;
    await this.setState({ [name]: value });
    this.fetchClearings(this.state.clearing.clearingId);
  };


  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  subtotal = (column) => {
    return this.state.clearings.reduce((sum, clearing) => sum + (clearing[column.id] || 0), 0).toLocaleString("de-DE");
  };

  handledownload = async () => {
    const { clearing, type } = this.state;
    const companyId = this.props.signedinuser.companyId;
    await ClearingUtils.getExcelFile(type, clearing.clearingId, companyId, true);
  };

  compareBy = (key, direction) => (a, b) => {
    if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
    if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
    return 0;
  };

  sortBy = (key) => {
    const { sortDirection, sortColumn, clearings } = this.state;
    const newDirection = key !== sortColumn ? "desc" : sortDirection === "asc" ? "desc" : "asc";
    this.setState({ clearings: [...clearings].sort(this.compareBy(key, newDirection)), sortDirection: newDirection, sortColumn: key });
  };

  render() {
    let columns = [];
    if (this.state.type === "Compensations") {
      columns = [
        { id: "damageYear", label: "Skadeår" },
        {
          id: "ib",
          label: "IB",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
          title:
            "IB: Inngående balanse dvs inngående IBNR + RBNS fra måned 12 foregående år",
        },
        {
          id: "paid",
          label: "Betalt",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
          title: "Betalt: utbetalt + innbetalt",
        },
        {
          id: "ub",
          label: "UB",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
          title:
            "UB: Utgående balanse dvs utgående IBNR + RBNS for avregningsmåned",
        },
        {
          id: "clearing",
          label: "Påløpne erstatninger",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
          title:
            "Påløpne erstatninger: For inneværende år - (Betalt + UB), ellers avviklingsresultat: IB - (Betalt + UB)",
        },
        {
          id: "percentage",
          label: "Andel(%)",
          align: "right",
          format: (value) =>
            value.toLocaleString(undefined, {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            }),
        },
        {
          id: "compIB",
          label: "IB",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "compPaid",
          label: "Betalt",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "compUB",
          label: "UB",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "compClearing",
          label: "Påløpne erstatninger",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
      ];
    }
    if (this.state.type === "Costs") {
      columns = [
        { id: "damageYear", label: "Skadeår" },
        {
          id: "costs",
          label: "Omkostninger",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "operatingExpenses",
          label: "Driftskostnader",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "percentage",
          label: "Andel(%)",
          align: "right",
          format: (value) =>
            value.toLocaleString(undefined, {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            }),
        },
        {
          id: "compCosts",
          label: "Omkostninger",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
        {
          id: "compOperatingExpenses",
          label: "Driftskostnader",
          align: "right",
          format: (value) => value.toLocaleString("de-DE"),
        },
      ];
    }

    return (
      <React.Fragment>
        <Container maxWidth="lg" sx={{ paddingTop: "80px" }}>
          <main sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", p: 3 }}>
              <CssBaseline />
              <Grid container sx={{ pt: 2 }}>

                {/* AVREGNING INFO */}
                <Grid container spacing={3} alignItems="center">
                  <Grid item lg="auto" sx={{ display: "flex", alignItems: "center", marginRight: 0 }}>
                    <Typography variant="h5">Avregning for:</Typography>
                  </Grid>

                  <Grid item lg={3}>
                    <FormControl fullWidth>
                      <TextField
                        label="Organisasjon"
                        value={this.state.clearing.organisationName || ""}
                        fullWidth
                        variant="standard"
                        InputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item lg={3}>
                    <FormControl fullWidth>
                      <TextField
                        label="År"
                        value={
                          this.state.clearing.toDate
                            ? new Date(this.state.clearing.toDate).getFullYear()
                            : ""
                        }
                        fullWidth
                        variant="standard"
                        InputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item lg={3}>
                    <FormControl fullWidth>
                      <TextField
                        label="Måned"
                        value={
                          this.state.clearing.toDate
                            ? new Date(this.state.clearing.toDate).getMonth() + 1
                            : ""
                        }
                        fullWidth
                        variant="standard"
                        InputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                {/* FILTERING OPTIONS */}
                <Grid container alignItems="center" spacing={1} sx={{ mt: 3, ml: 2 }}>
                  <Grid item sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: 15 }}>
                          Vis alle beløp i hele kroner akkumulert til avregningsmåned
                          innenfor året fram til og med avregningsmåned
                        </Typography>
                      }
                      placement="bottom-start"
                    >
                      <Typography variant="h6" sx={{ pt: 2, mr: 2 }}>Vis:</Typography>
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <RadioGroup
                      row
                      name="type"
                      value={this.state.type}
                      onChange={this.onChange}
                      sx={{ mt: 2.2 }}
                    >
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: 15 }}>
                            Erstatninger: Inn-/utgående avsetinger og netto betalinger pr skadeår
                          </Typography>
                        }
                        placement="bottom"
                      >
                        <FormControlLabel
                          value="Compensations"
                          control={<Radio color="primary" />}
                          label="Erstatninger"
                        />
                      </Tooltip>
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: 15 }}>
                            Kostnader: Saksomkostninger og TFF/YFFs interne kostnader pr skadeår
                          </Typography>
                        }
                        placement="bottom"
                      >
                        <FormControlLabel
                          value="Costs"
                          control={<Radio color="primary" />}
                          label="Kostnader"
                        />
                      </Tooltip>
                    </RadioGroup>
                  </Grid>



                  <Grid item>
                    <Typography variant="h6" sx={{ pt: 2, mx: 2, ml: -0.5 }}>
                      for
                    </Typography>
                  </Grid>

                  <Grid item lg={3}>
                    <FormControl variant="standard" fullWidth>
                      <InputLabel>Medlem</InputLabel>
                      <Select
                        name="companyId"
                        value={this.state.companyId || ""}
                        onChange={this.onChange}
                      >
                        <MenuItem value="">Alle</MenuItem>
                        {this.state.companiesByOrg.map((company, index) => (
                          <MenuItem key={index} value={company.companyId}>
                            {company.companyName + " (" + company.organisationName + ")"}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid sx={{ width: "100%", pt: 3 }}>
                  <Paper sx={{ overflow: "auto" }}>
                    <TableContainer>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            {columns.map((column) => (
                              <Tooltip
                                key={column.id}
                                title={
                                  <Typography sx={{ fontSize: 15 }}>
                                    {column.title || ""}
                                  </Typography>
                                }
                                placement="bottom-start"
                              >
                                <TableCell
                                  align={column.align}
                                  sx={{ backgroundColor: "#eeeeee", fontWeight: "bold", fontSize: 16 }}
                                  onClick={() => this.sortBy(column.id)}
                                >
                                  <TableSortLabel
                                    active={this.state.sortColumn === column.id}
                                    direction={this.state.sortDirection}
                                  >
                                    {column.label}
                                  </TableSortLabel>
                                </TableCell>
                              </Tooltip>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.clearings.length > 0 ? (
                            this.state.clearings
                              .slice(
                                this.state.page * this.state.rowsPerPage,
                                this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                              )
                              .map((clearing, index) => (
                                <TableRow hover key={index}>
                                  {columns.map((column) => {
                                    const value = clearing[column.id];
                                    return (
                                      <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === "number"
                                          ? column.format(value)
                                          : value}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={columns.length} align="center">
                                <Typography sx={{ py: 3 }}>Ingen treff</Typography>
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow hover>
                            {columns.map((column) => {
                              let sum = this.subtotal(column);
                              if (column.id === "damageYear") sum = "Total";
                              if (column.id === "percentage") sum = "";
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {sum}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={this.state.clearings.length}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </Paper>
                  <Grid sx={{ pt: 2, pb: 2 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CloudDownloadIcon />}
                      onClick={this.handledownload}
                    >
                      Vis i Excel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { signedinuser: state.signedinuserobject?.signedInUser || JSON.parse(sessionStorage.getItem("token")) || [] };
}

export default withParams(connect(mapStateToProps)(ClearingDetailsAdmin));
